module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.prefixCls
  }, [_c('i-input', {
    attrs: {
      "size": "small",
      "icon": _vm.icon,
      "placeholder": _vm.placeholder
    },
    on: {
      "on-click": _vm.handleClick
    },
    model: {
      value: (_vm.currentQuery),
      callback: function($$v) {
        _vm.currentQuery = $$v
      },
      expression: "currentQuery"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-181071c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/transfer/search.vue
// module id = 598
// module chunks = 1